/**
 * Shop category facets: top-level groups + アクセサリー with native Shopify sub-tabs.
 */
(function () {
  function getFacetForms() {
    return [
      document.getElementById('FacetFiltersForm'),
      document.getElementById('FacetFiltersFormMobile'),
    ].filter(Boolean);
  }

  function clearAllTaxonomy(form) {
    form.querySelectorAll('input[data-shop-taxonomy]').forEach((input) => {
      input.checked = false;
    });
  }

  function getAccessoryParent(form) {
    return form.querySelector('[data-shop-accessory-parent]');
  }

  function getAccessoryTaxonomyInputs(parent) {
    if (!parent) return [];
    return [...parent.querySelectorAll('input[data-shop-accessory-taxonomy]:not(:disabled)')];
  }

  function hideAccessorySubTabs(parent) {
    const subTabs = parent?.querySelector('[data-shop-accessory-sub-tabs]');
    if (subTabs) subTabs.hidden = true;
    parent?.classList.remove('shop-category-facet__group--accessory-active');
  }

  function showAccessorySubTabs(parent) {
    const subTabs = parent?.querySelector('[data-shop-accessory-sub-tabs]');
    if (subTabs) subTabs.hidden = false;
    parent?.classList.add('shop-category-facet__group--accessory-active');
  }

  function setActiveSubTab(parent, tabKey) {
    parent.querySelectorAll('[data-shop-accessory-tab]').forEach((tab) => {
      const isActive = tab.getAttribute('data-shop-accessory-tab') === tabKey;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function inferActiveSubTabKey(parent) {
    const inputs = getAccessoryTaxonomyInputs(parent);
    const checked = inputs.filter((input) => input.checked);
    if (checked.length === 0) return null;
    if (checked.length === inputs.length) return 'all';
    if (checked.length === 1) return checked[0].getAttribute('data-shop-taxonomy-value');
    return 'all';
  }

  function applyAccessoryTaxonomy(parent, tabKey) {
    const inputs = getAccessoryTaxonomyInputs(parent);
    inputs.forEach((input) => {
      input.checked = false;
    });

    if (tabKey === 'all') {
      inputs.forEach((input) => {
        input.checked = true;
      });
    } else {
      const match = parent.querySelector(
        `input[data-shop-accessory-taxonomy][data-shop-taxonomy-value="${CSS.escape(tabKey)}"]`
      );
      if (match && !match.disabled) match.checked = true;
    }

    setActiveSubTab(parent, tabKey);
  }

  function submitFacetForm(form) {
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function uncheckTopRadios(form) {
    form.querySelectorAll('[data-shop-category-radio]').forEach((radio) => {
      radio.checked = false;
    });
  }

  function syncAccessoryUI(form) {
    const parent = getAccessoryParent(form);
    if (!parent) return;

    const accessoryCheck = parent.querySelector('[data-shop-accessory-check]');
    const checkedInputs = parent.querySelectorAll(
      'input[data-shop-accessory-taxonomy]:checked:not(:disabled)'
    );

    if (checkedInputs.length === 0) {
      if (accessoryCheck) accessoryCheck.checked = false;
      hideAccessorySubTabs(parent);
      return;
    }

    if (accessoryCheck) accessoryCheck.checked = true;
    showAccessorySubTabs(parent);

    const tabKey = inferActiveSubTabKey(parent);
    if (tabKey) setActiveSubTab(parent, tabKey);
  }

  function syncRadiosFromTaxonomy(form) {
    if (!form) return;

    form.querySelectorAll('[data-shop-group]:not([data-shop-accessory-parent])').forEach((group) => {
      const radio = group.querySelector('[data-shop-category-radio]');
      const checked = group.querySelector('input[data-shop-taxonomy]:checked:not(:disabled)');
      if (radio) radio.checked = !!checked;
    });

    syncAccessoryUI(form);
  }

  function applyTopLevelRadio(radio, form) {
    const group = radio.closest('[data-shop-group]');
    if (!group || !form) return;

    const parent = getAccessoryParent(form);
    if (parent) {
      const accessoryCheck = parent.querySelector('[data-shop-accessory-check]');
      if (accessoryCheck) accessoryCheck.checked = false;
      hideAccessorySubTabs(parent);
    }

    clearAllTaxonomy(form);

    group.querySelectorAll('input[data-shop-taxonomy]:not(:disabled)').forEach((input) => {
      input.checked = true;
    });

    submitFacetForm(form);
  }

  function applyAccessoryCheck(checkbox, form) {
    const parent = getAccessoryParent(form);
    if (!parent) return;

    if (!checkbox.checked) {
      clearAllTaxonomy(form);
      hideAccessorySubTabs(parent);
      submitFacetForm(form);
      return;
    }

    uncheckTopRadios(form);
    clearAllTaxonomy(form);
    showAccessorySubTabs(parent);
    applyAccessoryTaxonomy(parent, 'all');
    submitFacetForm(form);
  }

  function applyAccessorySubTab(tab, form) {
    const parent = tab.closest('[data-shop-accessory-parent]');
    if (!parent) return;

    const accessoryCheck = parent.querySelector('[data-shop-accessory-check]');
    if (accessoryCheck) accessoryCheck.checked = true;

    uncheckTopRadios(form);
    clearAllTaxonomy(form);
    showAccessorySubTabs(parent);

    const tabKey = tab.getAttribute('data-shop-accessory-tab');
    applyAccessoryTaxonomy(parent, tabKey);
    submitFacetForm(form);
  }

  function onFormChange(event) {
    const form = event.currentTarget;

    const accessoryCheck = event.target.closest('[data-shop-accessory-check]');
    if (accessoryCheck && form.contains(accessoryCheck)) {
      applyAccessoryCheck(accessoryCheck, form);
      return;
    }

    const radio = event.target.closest('[data-shop-category-radio]');
    if (radio && form.contains(radio) && !radio.hasAttribute('data-shop-category-child-radio')) {
      applyTopLevelRadio(radio, form);
    }
  }

  function onFormClick(event) {
    const form = event.currentTarget;
    const tab = event.target.closest('[data-shop-accessory-tab]');
    if (!tab || !form.contains(tab)) return;

    event.preventDefault();
    applyAccessorySubTab(tab, form);
  }

  function bindForm(form) {
    if (!form || !form.querySelector('[data-shop-category-facets]')) return;

    if (form.dataset.shopCategoryFacetsBound !== 'true') {
      form.addEventListener('change', onFormChange);
      form.addEventListener('click', onFormClick);
      form.dataset.shopCategoryFacetsBound = 'true';
    }

    syncRadiosFromTaxonomy(form);
  }

  function init() {
    getFacetForms().forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.__initShopCategoryFacets = init;
})();
